var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var BaseCalculation_1;
import { DateConverter, JSON, JsonConverter, JsonDiscriminatorProperty, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { CalculationType } from './baseCalculationRequest';
export var CalculationStatus;
(function (CalculationStatus) {
    CalculationStatus["Running"] = "running";
    CalculationStatus["Failed"] = "failed";
    CalculationStatus["Cancelled"] = "cancelled";
    // Complete = 'complete' // Deprecated, replaced by Completed
    CalculationStatus["Completed"] = "completed";
})(CalculationStatus || (CalculationStatus = {}));
export var CalculationErrorCodes;
(function (CalculationErrorCodes) {
    CalculationErrorCodes["Unknown"] = "calculation.unknown";
    CalculationErrorCodes["OutOfMemory"] = "calculation.outOfMemory";
    CalculationErrorCodes["Timeout"] = "calculation.timeout";
    CalculationErrorCodes["EmptyTrainingTargetColumn"] = "calculation.emptyTrainingTargetColumn";
    CalculationErrorCodes["ExportFailed"] = "calculation.exportFailed";
    CalculationErrorCodes["MalformedRows"] = "calculation.hasMalformedRows";
    CalculationErrorCodes["NaiveBayesNegativeValue"] = "calculation.naiveBayesNegativeValue";
    CalculationErrorCodes["DateAddError"] = "calculation.dateAddError";
    CalculationErrorCodes["OutOfBoundsValue"] = "calculation.outOfBoundsValue";
    CalculationErrorCodes["PySparkMultiClassError"] = "calculation.pysparkMulticlassTarget";
    CalculationErrorCodes["UnicodeDecodeError"] = "calcuation.unicodeDecodeError";
    CalculationErrorCodes["OutOfCredits"] = "calculation.outOfCredits";
    CalculationErrorCodes["NotEnoughData"] = "calculation.notEnoughData";
    CalculationErrorCodes["Inactive"] = "calculation.inactive";
    CalculationErrorCodes["NoCalculatedResults"] = "calculation.noCalculatedResults";
    CalculationErrorCodes["DataSourceDoesNotExist"] = "calculation.dataSourceDoesNotExist";
})(CalculationErrorCodes || (CalculationErrorCodes = {}));
const schema = {
    $id: 'urn:wisepipe-common-computation:BaseCalculation',
    type: 'object',
    properties: {
        type: { type: 'string', enum: Object.values(CalculationType) },
        status: { type: 'string', enum: Object.values(CalculationStatus) },
        progress: { type: 'number', minimum: 0, maximum: 1 },
        start: { type: 'string', format: 'date-time' },
        end: { type: 'string', format: 'date-time' },
        error: { type: 'object' }
    },
    required: ['status', 'progress', 'start', 'type']
};
let BaseCalculation = BaseCalculation_1 = class BaseCalculation {
    constructor(type, status, progress, start, end, error) {
        this.type = type;
        this.status = status;
        this.progress = progress;
        this.start = start;
        if (end)
            this.end = end;
        if (error !== undefined)
            this.error = error;
        JSON.validate(this, BaseCalculation_1);
    }
    static getTableName(userID, objectID, elementID, port) {
        return `${userID}/${objectID}/${elementID}/${port}`;
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], BaseCalculation.prototype, "start", void 0);
__decorate([
    JsonConverter(new DateConverter('date-time'))
], BaseCalculation.prototype, "end", void 0);
BaseCalculation = BaseCalculation_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorProperty('type')
], BaseCalculation);
export { BaseCalculation };
//# sourceMappingURL=baseCalculation.js.map